import { jsx as _jsx } from "react/jsx-runtime";
import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { TopbarButton } from '../topbarButton';
export const SmsTopbarButton = () => {
    const dispatch = useAppDispatch();
    const openCompose = () => {
        dispatch(appActions.showModal({
            modal: {
                type: 'app:composeSms',
            },
        }));
    };
    return (_jsx(TopbarButton, { onClick: () => openCompose(), icon: "sms", tooltip: "New sms" }));
};
